import { render } from "./PCOS.vue?vue&type=template&id=63c1ef63"
import script from "./PCOS.vue?vue&type=script&lang=js"
export * from "./PCOS.vue?vue&type=script&lang=js"

import "./PCOS.vue?vue&type=style&index=0&id=63c1ef63&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__